import { ApiNote } from '../../../../../../api/_legacy/generated-api'
import { ProgressContainer, SimpleModal } from '../../../../../../components/core-v2'
import { ExistingNoteState } from '../existing-note-slice'
import { InspectNote } from './inspect'
import { NoteSearch } from './search'

type Props = {
  onBackToSearch: () => void
  onInspectNote: (note: ApiNote) => void
  onSelectNote: (note: ApiNote) => void
  onStopFindingNote: () => void
  state: ExistingNoteState
}

export const NoteFinder = ({
  onBackToSearch,
  onInspectNote,
  onSelectNote,
  onStopFindingNote,
  state
}: Props) => (
  <SimpleModal>
    <ProgressContainer
      currentStep={state.findStatus === 'finding' ? 1 : 2}
      numSteps={2}
      title="Find a note"
      onClickClose={() => onStopFindingNote()}
    >
      {state.findStatus === 'finding' && <NoteSearch onClickNote={note => onInspectNote(note)} />}
      {state.findStatus === 'inspecting' && (
        <InspectNote
          businessUnit={state.businessUnit}
          client={state.client}
          fees={state.fees}
          note={state.note}
          noteTotalValue={state.selectedNoteTotalValue}
          onBackToSearch={() => onBackToSearch()}
          onSelectNote={note => onSelectNote(note)}
        />
      )}
    </ProgressContainer>
  </SimpleModal>
)
